import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@upmc/ims.component-library';

import Confirm from '../../components/AppCart/GenericApps/Confirm/Confirm';
import { HomeButton } from '../../components/UI/Input/Button/index';
import Icon from '../../components/UI/MDC/Icon/Icon';
import { getLegacyPath } from 'routes/_utils';

/**
 * Functional component to confirm request submissions.
 * Raises 'Success' message banner, renders card with text, footer action buttons for navigation.
 * @param {Object} props Properties passed to component.
 * @returns {React.ReactElement} Rendered component.
 */
const Confirmation = () => {
	const history = useHistory();

	return (
		<Confirm
			actionButtons={[
				<Button
					sx={{ mr: '5px' }}
					onClick={() => {
						history.push(getLegacyPath('/RRS/Requests.aspx'));
					}}
					variant='outlined'
					endIcon={<Icon icon='history' />}
				>
					View Requests
				</Button>,
				<HomeButton icon />,
			]}
			bodyMessage='Your requests have been successfully submitted.'
		/>
	);
};

export default Confirmation;
